// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1iv4E","head":"Table_head__36ee0","col":"Table_col__39qul"};